module.exports = __webpack_public_path__ + "img/manager.0efea039.svg";